module.exports = __webpack_public_path__ + "fnt/cd6c777f1945164224dee082abaea03a.woff2";